/**
 * About This Product Accordion Functionality
 * Handles accordion open/close behavior and accessibility
 */

document.addEventListener('DOMContentLoaded', function() {
  const accordionItems = document.querySelectorAll('.about-product-accordion .accordion-item');
  
  if (accordionItems.length === 0) return;

  // Initialize accordion behavior
  accordionItems.forEach(item => {
    const summary = item.querySelector('summary');
    const content = item.querySelector('.accordion-content');
    
    if (!summary || !content) return;

    // Add keyboard support
    summary.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion(item);
      }
    });

    // Add click support
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      toggleAccordion(item);
    });

    // Close accordion by default (optional - remove if you want them open)
    item.removeAttribute('open');
  });

  function toggleAccordion(item) {
    const isOpen = item.hasAttribute('open');
    
    if (isOpen) {
      item.removeAttribute('open');
    } else {
      item.setAttribute('open', '');
    }
  }

  // Optional: Close other accordions when one opens (accordion behavior)
  // Uncomment the following code if you want only one accordion open at a time
  
  /*
  accordionItems.forEach(item => {
    const summary = item.querySelector('summary');
    
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Close all other accordions
      accordionItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.removeAttribute('open');
        }
      });
      
      // Toggle current accordion
      toggleAccordion(item);
    });
  });
  */
});
